import * as React from 'react';

import * as styles from './CallSourceWish.css';

export function CallSourceWish() {
  return <div className={styles['wish']}>Пожалуйста, скажите, что нашли это объявление на ЦИАН</div>;
}
